import { Typography, alpha, useTheme } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { isSideDrawerExpandedState } from 'states';

interface GroupHeaderProps {
  title: string;
}

const GroupHeader = ({ title }: GroupHeaderProps) => {
  const theme = useTheme();
  const isDrawerExpanded = useRecoilValue(isSideDrawerExpandedState);

  return (
    <Typography
      sx={{
        textTransform: 'uppercase',
        color: alpha(theme.palette.text.primary, 0.55),
        fontWeight: 300,
        opacity: isDrawerExpanded ? 100 : 0,
      }}
    >
      {title}
    </Typography>
  );
};

export default GroupHeader;
